var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { elementDateTime } from './Program.js';
const formEditMap = new Map();
formEditMap.set('defaultLayout', (component) => {
    return html `<div slot="content">
        <span>Created:</span>
        <br/>
        <span>${elementDateTime(component.CreatedDate)}</span>
        <br/>
        <span>${component.CreatedPerson}</span>
        <br/>
        <span>Updated:</span>
        <br/>
        <span>${elementDateTime(component.UpdatedDate)}</span>
        <br/>
        <span>${component.UpdatedPerson}</span>
    </div>`;
});
formEditMap.set('createdLayout', (component) => {
    return html `<div slot="content">
        <span>Created:</span>
        <br/>
        <span>${elementDateTime(component.CreatedDate)}</span>
        <br/>
        <span>${component.CreatedPerson}</span>
    </div>`;
});
formEditMap.set('updatedLayout', (component) => {
    return html `<div slot="content">
        <span>Updated:</span>
        <br/>
        <span>${elementDateTime(component.UpdatedDate)}</span>
        <br/>
        <span>${component.UpdatedPerson}</span>
    </div>`;
});
let QboFormEdit = class QboFormEdit extends LitElement {
    constructor() {
        super(...arguments);
        this.aDropdownClass = 'dropdown-item qbo-pointer';
        this.buttonPrimaryClass = 'qbo-primary';
        this.buttonPrimaryDropdownClass = 'qbo-primary-dropdown';
        this.buttonType = 'button';
        this.data = {};
        this.divButtonGroupClass = 'qbo-btn-group';
        this.divFormActionClass = 'qbo-form-actions';
        this.divSectionHeaderClass = 'qbo-header';
        this.dropdownToggle = 'dropdown';
        this.editLabel = 'Edit';
        this.helpIcon = 'qbo-icon-question';
        this.helpText = 'Help';
        this.historyIcon = 'qbo-icon-clock-history';
        this.historyText = 'History';
        this.infoButtonClass = 'qbo-btn-light';
        this.infoIconClass = 'qbo-icon-info';
        this.infoTitle = 'Last Updated';
        this.popoverClass = 'qbo-float-end';
        this.spanEditClass = 'qbo-icon-edit';
        this.ulDropdownClass = 'dropdown-menu';
        this.type = 'defaultLayout';
        this.renderInHost = true;
    }
    createRenderRoot() {
        return this.renderInHost ? this : super.createRenderRoot();
    }
    render() {
        if (this.type == null)
            this.type = 'defaultLayout';
        const popover = formEditMap.has(this.type) ? formEditMap.get(this.type)(this.data) : null;
        return html `<slot>
            <div class="${this.divSectionHeaderClass}">
                <hr />
            </div>
            <div class="${this.divFormActionClass}">
                <div class="${this.divButtonGroupClass}">
                    <button type="${this.buttonType}" class="${this.buttonPrimaryClass}">
                        <i class="${this.spanEditClass}"></i> ${this.editLabel}
                    </button>
                    <button type="${this.buttonType}" class="${this.buttonPrimaryDropdownClass}" data-bs-toggle="${this.dropdownToggle}"></button>
                    <ul class="${this.ulDropdownClass}">
                        <li>
                            <a class="${this.aDropdownClass}" onclick="alert('Show History');">
                                <i class="${this.historyIcon}"></i>
                                <span>${this.historyText}</span>
                            </a>
                        </li>
                        <li>
                            <a class="${this.aDropdownClass}" onclick="alert('Show Help');">
                                <i class="${this.helpIcon}"></i>
                                <span>${this.helpText}</span>
                            </a>
                        </li>
                    </ul>
                </div>
                <qbo-popover class="${this.popoverClass}">
                    <button type="${this.buttonType}" class="${this.infoButtonClass}" title="${this.infoTitle}">
                        <i class="${this.infoIconClass}"></i>
                    </button>
                    ${popover}
                </qbo-popover>
            </div>
        </slot>`;
    }
};
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboFormEdit.prototype, "aDropdownClass", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboFormEdit.prototype, "buttonPrimaryClass", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboFormEdit.prototype, "buttonPrimaryDropdownClass", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboFormEdit.prototype, "buttonType", void 0);
__decorate([
    property({ type: Object, attribute: false }),
    __metadata("design:type", Object)
], QboFormEdit.prototype, "data", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboFormEdit.prototype, "divButtonGroupClass", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboFormEdit.prototype, "divFormActionClass", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboFormEdit.prototype, "divSectionHeaderClass", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboFormEdit.prototype, "dropdownToggle", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboFormEdit.prototype, "editLabel", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboFormEdit.prototype, "helpIcon", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboFormEdit.prototype, "helpText", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboFormEdit.prototype, "historyIcon", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboFormEdit.prototype, "historyText", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboFormEdit.prototype, "infoButtonClass", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboFormEdit.prototype, "infoIconClass", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboFormEdit.prototype, "infoTitle", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboFormEdit.prototype, "popoverClass", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboFormEdit.prototype, "spanEditClass", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboFormEdit.prototype, "ulDropdownClass", void 0);
__decorate([
    property(),
    __metadata("design:type", Object)
], QboFormEdit.prototype, "type", void 0);
__decorate([
    property({ type: Boolean }),
    __metadata("design:type", Object)
], QboFormEdit.prototype, "renderInHost", void 0);
QboFormEdit = __decorate([
    customElement('qbo-form-edit')
], QboFormEdit);
export { QboFormEdit };
